<template>
  <v-popup @close="checkAndEmitClose" :loading="loading">
    <v-process-progress-bar :options="options" :current-item-index="progressIndex" />

    <v-order-confirmation-addresses
      v-if="progressIndex === 1"
      :addresses="addresses"
      :selected-address-id.sync="selectedAddressId"
      @update="fetchAddresses"
      @continue="progressIndex = 2"
    />

    <v-order-confirmation-purchase-document
      v-else-if="basicData.purchaseDocumentRequired && progressIndex === 2"
      :purchase-document.sync="purchaseDocument"
      @cancel="progressIndex = 1"
      @continue="progressIndex = 3"
    />

    <v-order-confirmation-summary
      v-else-if="progressIndex === (basicData.purchaseDocumentRequired ? 3 : 2)"
      :delivery-address="selectedDeliveryAddress"
      :purchase-document="purchaseDocument"
      @saved="onOrderSaved"
    />

    <v-order-saved-screen
      v-else-if="progressIndex === (basicData.purchaseDocumentRequired ? 4 : 3)"
      :order-id="$route.query.orderId"
    />
  </v-popup>
</template>

<script>
import { mapGetters } from "vuex";
import { VPopup, VProcessProgressBar } from "shared";
import VOrderConfirmationAddresses from "./v-order-confirmation-addresses";
import VOrderConfirmationSummary from "./v-order-confirmation-summary";
import VOrderConfirmationPurchaseDocument from "./v-order-confirmation-purchase-document";
import VOrderSavedScreen from "./v-order-saved-screen";
import * as AddressesDAO from "../../dao/addresses-dao";

export default {
  name: "VOrderConfirmationPopup",
  components: {
    VOrderConfirmationAddresses,
    VOrderConfirmationSummary,
    VOrderConfirmationPurchaseDocument,
    VOrderSavedScreen,
    VPopup,
    VProcessProgressBar
  },
  data() {
    return {
      purchaseDocument: null,
      loading: true,
      selectedAddressId: 1,
      addresses: null,
      savedOrderId: null
    };
  },

  computed: {
    ...mapGetters("order", ["basicData"]),
    options() {
      if (this.basicData.purchaseDocumentRequired) {
        return [
          this.$t("page.order.confirmation.step.canisterlist"),
          this.$t("page.order.confirmation.step.address"),
          this.$t("page.order.confirmation.step.purchasedocument"),
          this.$t("page.order.confirmation.step.confirm"),
          this.$t("page.order.confirmation.step.done")
        ];
      } else {
        return [
          this.$t("page.order.confirmation.step.canisterlist"),
          this.$t("page.order.confirmation.step.address"),
          this.$t("page.order.confirmation.step.confirm"),
          this.$t("page.order.confirmation.step.done")
        ];
      }
    },

    selectedDeliveryAddress() {
      return this.addresses.find(address => address.id === this.selectedAddressId);
    },
    progressIndex: {
      get() {
        return +this.$route.query.confirmationStep;
      },
      set(value) {
        this.$router.push({ query: { confirmationStep: value } });
      }
    }
  },

  methods: {
    async fetchAddresses() {
      this.loading = true;
      this.addresses = await AddressesDAO.getAddresses();
      if (!this.selectedAddressId || !this.addresses.find(a => a.id === this.selectedAddressId)) {
        this.selectedAddressId = this.addresses[0].id;
      }
      this.addresses = await AddressesDAO.getAddresses();
      this.loading = false;
    },
    onOrderSaved(order) {
      this.$router.push({
        query: {
          confirmationStep: this.basicData.purchaseDocumentRequired ? 4 : 3,
          orderId: order.id
        }
      });

      this.$emit("saved");
    },
    checkAndEmitClose() {
      if (this.progressIndex !== (this.basicData.purchaseDocumentRequired ? 4 : 3)) {
        this.$emit("close");
      }
    }
  },

  async created() {
    await this.fetchAddresses();
  },

  watch: {
    $route(to, from) {
      if (to.query.confirmationStep && +from.query.confirmationStep === 4) {
        window.history.forward(1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .popup {
  &__container {
    width: 712px;
    padding: 64px 64px 80px 64px;
    min-height: 715px;
    min-width: 0;
  }
}
</style>
